import React, { useEffect, useState } from "react";
// import { useHistory } from "react-router";
import {
  Col,
  Row,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
  Table,
  FormFeedback,
  Card,
  CardBody,
  CardTitle,
  Alert,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import {
  DOG_LICENSE_DETAILS,
  AGENCY_FEE,
  PAYMENT_PROCESS,
  GET_USER,
  UPDATE_LICENSE_STATUS,
  STATE_LIST,
} from "../../../constants/ApiPaths";
import { authCustomerHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import {
  CardSwipe,
  JSONParser,
  luhnChecksum,
  parseCreditCards,
} from "../../../functions/Helper";

import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import CustomButtonLoader from "../../CustomComponents/CustomButtonLoader";

const paymentInitial = {
  firstName: "",
  lastName: "",
  address1: "",
  city: "",
  state: "",
  zip: "",
  phone: "",
  email: "",
  cardNumber: "",
  expirationMonth: "",
  expirationYear: "",
  cvv2: "",
  userId: 0,
  dogLicenseId: 0,
  paymentType: "",
  responseText: "",
};

export default function PaymentWithPlan(props) {
  // const { dogLicenseId, userId, ttId } = useParams();
  const {
    dogLicenseId,
    userId,
    ResetAllFormFields,
    currentStep,
    setMoreFlag,
    licenseDetails,
    stateList,
  } = props;
  const { dogId } = licenseDetails || [];
  const ttId = localStorage.getItem("TTID");
  const [loading, setloading] = useState(false);
  const [texloading, settexloading] = useState(false);
  const [isPaymentSuccess, setIsPaymentSuccess] = useState(false);
  const [paymentValues, setpaymentValues] = useState({});
  const [agencyFee, setagencyFee] = useState({});
  const { licensePlanDetails, categoryDetails } = paymentValues;
  const licensePlanData = JSONParser(licensePlanDetails, []);
  const categorydata = JSONParser(categoryDetails, []);
  // const { categoryAnswer } = categorydata[0] || {};
  const Answer = categorydata.map((ans) => JSONParser(ans.categoryAnswer, []));
  const answerData = [];
  Answer &&
    Answer.forEach((A) => {
      A.categoryPlaceHolder.forEach((field) => {
        answerData.push({
          label: field?.label,
          // key: field.uniqueId,
          value: field.selectedAnswer,
        });
      });
    });


  const {
    planAmount,
    planName,
    licensePlanId,
    planDescription,
    isDogLicense,
    isKennelLicense,
    isLifeTimePlan,
    isParkLicense,
    isRenewal,
    planDuration,
    templateId,
    isActive,
  } = licensePlanData[0] || {};
  const [documentUrl, setDocumentUrl] = useState("");
  const [paymentLoader, setPaymentLoad] = useState("");
  const [address, setAddress] = useState();
  const [citych, setCity] = useState();
  const [pscode, setPsCode] = useState();
  const [stname, setState] = useState(1);
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingcity, setIsEditingcity] = useState(false);
  const [isEditingps, setIsEditingps] = useState(false);
  const [isEditingst, setIsEditingst] = useState(false);

  const cardholderName = {
    firstName: "",
    lastName: "",
  };
  const reset = () => {
    setValues("");
    setMoreFlag(true);
    setpaymentValues({});
    setagencyFee("");
    setIsPaymentSuccess(false);
    ResetAllFormFields();
    resetForm({});
    setTouched("");

    setErrors("");
  };
  const Total = parseFloat(planAmount) + parseFloat(agencyFee);
  const Year = () => {
    const d = new Date();
    const n = d.getFullYear();
    const year = [];
    for (let index = n; index < n + 50; index++) {
      year.push({ value: index.toString().substr(-2), year: index });
    }
    return year;
  };

  const year = Year();

  const GetUser = async () => {
    setloading(true);
    const config = {
      method: "GET",
      url: GET_USER,
      // headers: authCustomerHeader(),
      params: {
        userId: userId,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setValues({
          ...data,
          expirationMonth: values.expirationMonth,
          expirationYear: values.expirationYear,
          cvv2: values.cvv2,
          cardNumber: values.cardNumber,
          address1: data.address,
          state: data.stateId,
        });
        // setErrors({});
        setAddress(data.address);
        setCity(data.city);
        setPsCode(data.zip);
        setState(data.stateId);
      }
    } catch (error) {
      if (error.response) {
        console.log(error);
      }
    } finally {
      setloading(false);
    }
  };

  const { enqueueSnackbar } = useSnackbar();

  const PaymentDetails = async (e) => {
    setloading(true);
    const config = {
      method: "GET",
      url: DOG_LICENSE_DETAILS,
      // headers: authCustomerHeader(),
      params: {
        dogLicenseId: dogLicenseId,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setpaymentValues(data);
        const { licensePlanDetails } = data;
        const licensePlanData = JSONParser(licensePlanDetails, []);
        const { planAmount } = licensePlanData[0] || {};
        AgencyFee(planAmount);
      }
    } catch (error) {
    } finally {
      setloading(false);
    }
  };

  const AgencyFee = async (planAmount) => {
    settexloading(true);
    const config = {
      method: "GET",
      url: AGENCY_FEE,
      // headers: authCustomerHeader(),
      params: {
        ttId: ttId,
        amount: planAmount,
      },
    };
    try {
      const response = await API(config);
      const { status, ServiceFeeAmount } = response.data;
      if (status === "Success") {
        setagencyFee(ServiceFeeAmount);
      }
    } catch (error) {
    } finally {
      settexloading(false);
    }
  };

  const paymentProcess = async () => {
    setPaymentLoad(true);
    const config = {
      method: "POST",
      url: PAYMENT_PROCESS,
      headers: authCustomerHeader(),
      data: {
        firstName: values.firstName,
        lastName: values.lastName,
        address1: address,
        city: citych,
        state: String(stname), // changed to string in migration fix,
        zip: pscode,
        phone: values.phoneNumber,
        email: values.email,
        cardNumber: values.cardNumber,
        expirationMonth: values.expirationMonth,
        expirationYear: values.expirationYear,
        cvv2: values.cvv2,
        userId: String(userId),
        //userId: parseInt(userId), changed in migration due ti error from DB
        dogLicenseId: parseInt(dogLicenseId),
        paymentType: "Debit card",
        licenseData: {
          dogId: dogId,
          userId: userId,
          planAmount: planAmount,
          planName,
          licensePlanId,
          planDescription,
          isDogLicense,
          isKennelLicense,
          isLifeTimePlan,
          isParkLicense,
          isRenewal,
          planDuration,
          templateId,
          isActive,
          categoryAnswer: answerData,
        },
      },
    };
    try {
      const response = await API(config);

      const { status, documentUrl } = response.data;
      if (status === "Success") {
        const licplanId = window.sessionStorage.getItem(
          "PAYMENT_DOGLICENSE_LICENSEPLANID"
        );
        // const { licenseUrl = "" } = data;
        setDocumentUrl(documentUrl);
        const conf = {
          method: "PUT",
          url: UPDATE_LICENSE_STATUS,
          data: {
            dogLicenseId: dogLicenseId,
            licenseStatus: "Payment Completed",
            licensePlanId: licplanId,
          },
        };
        try {
          const response1 = await API(conf);
        } catch (error) {
          console.error(error);
        }
        setIsPaymentSuccess(true);
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setPaymentLoad(false);
      setIsEditing(false);
    }
  };

  const validationSchema = Yup.object({
    firstName: Yup.string().trim().required("First name is required"),
    lastName: Yup.string().trim().required("Last name is required"),
    expirationMonth: Yup.string()
      .trim()
      .required(" Expiration Month is required"),
    expirationYear: Yup.string().trim().required("Expiration Year is required"),
    cardNumber: Yup.string()
      .trim()
      .min(16, "Card Number is invalid")
      .max(16, "Card Number is invalid")
      .required("Card Number is required"),
    cvv2: Yup.string()
      .min(3, "Cvv Number is invalid")
      .max(4, "Cvv Number is invalid")
      .trim()
      .required("Cvv is required"),
  });
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    setValues,
    touched,
    setErrors,
    resetForm,
    handleBlur,
    setTouched,
  } = useFormik({
    initialValues: { ...paymentInitial, ...cardholderName },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => paymentProcess(values),
  });

  useEffect(() => {
    if (userId && parseInt(currentStep) === 5) {
      PaymentDetails();
      GetUser();
      // fetchStateList()
      // setErrors({});
    }
  }, [userId, currentStep]);

  // if (loading) {
  //   return <CustomPageLoading />;
  // }

  const CardHandle = (e) => {
    const { value } = e.target;
    const { cardNumber, ...otherValues } = CardSwipe(value);
    if (luhnChecksum(cardNumber)) {
      setValues({
        ...values,
        cardNumber,
        ...otherValues,
      });
      return;
    }
    const parsedValues = parseCreditCards(value);
    if (parsedValues) {
      setValues({
        ...values,
        ...parsedValues,
      });
      return;
    }
    setValues({
      ...values,
      cardNumber: value,
    });
  };

  const handleAddressChange = (e) => {
    setAddress(e.target.value);
  };
  const handleCityChange = (e) => {
    setCity(e.target.value);
  };
  const handlezipChange = (e) => {
    setPsCode(e.target.value);
  };
  const handlestateChange = (e) => {
    setState(e.target.value);
  };
  const handleEditClick = () => {
    setIsEditing(true);
  };
  const handleEditClickcity = () => {
    setIsEditingcity(true);
  };
  const handleEditClickps = () => {
    setIsEditingps(true);
  };
  const handleEditClickst = () => {
    setIsEditingst(true);
  };

  const captureAndDownloadPDF = () => {
    window.open(documentUrl, '_blank');
 };
    
  return (
    <React.Fragment>
      <Row>
        <Col md={6}>
          <Card>
            <CardBody>
              <CardTitle>
                <center>CardHolder Information</center>
              </CardTitle>

              <div className="kt-widget__content">
                <div className="kt-widget__info mb-2">
                  <span className="kt-widget__label"> First Name :</span>
                  {values.firstName || "N/A"}
                </div>
                <div className="kt-widget__info mb-2">
                  <span className="kt-widget__label">Last Name : </span>
                  {values.lastName || "N/A"}
                </div>
                <div className="kt-widget__info mb-2">
                  <span className="kt-widget__label">Email :</span>
                  {values.email || "N/A"}
                </div>
                <div className="kt-widget__info mb-2">
                  <span className="kt-widget__label">Phone Number :</span>
                  {values.phoneNumber ? `(+1) ${values.phoneNumber}` : "N/A"}
                </div>
                <div className="kt-widget__info mb-2">
                  <span className="kt-widget__label">Billing Address :</span>
                  <span className="kt-widget__data">
                    {isEditing ? (
                      <input
                        type="text"
                        value={address}
                        onChange={handleAddressChange}
                        placeholder="Enter Address"
                        className="form-control"
                      />
                    ) : (
                      <>
                        {address || "N/A"}
                        <Button
                          className="editBtn"
                          color="link"
                          onClick={handleEditClick}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10.928"
                            height="10.928"
                            viewBox="0 0 10.928 10.928"
                          >
                            <path
                              id="Icon_material-mode-edit"
                              data-name="Icon material-mode-edit"
                              d="M4.5,13.148v2.276H6.776L13.49,8.711,11.214,6.434Zm10.75-6.2a.6.6,0,0,0,0-.856l-1.42-1.42a.6.6,0,0,0-.856,0L11.863,5.785,14.14,8.061,15.25,6.95Z"
                              transform="translate(-4.5 -4.496)"
                              fill="#1b3e6f6b"
                            />
                          </svg>
                        </Button>
                      </>
                    )}
                  </span>{" "}
                </div>
                <div className="kt-widget__info mb-2">
                  <span className="kt-widget__label">City :</span>
                  <span className="kt-widget__data">
                    {/* {values.city || "N/A"} */}
                    {isEditingcity ? (
                      <input
                        type="text"
                        value={citych}
                        onChange={handleCityChange}
                        placeholder="Enter City"
                        className="form-control"
                      />
                    ) : (
                      <>
                        {citych || "N/A"}
                        <Button
                          className="editBtn"
                          color="link"
                          onClick={handleEditClickcity}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10.928"
                            height="10.928"
                            viewBox="0 0 10.928 10.928"
                          >
                            <path
                              id="Icon_material-mode-edit"
                              data-name="Icon material-mode-edit"
                              d="M4.5,13.148v2.276H6.776L13.49,8.711,11.214,6.434Zm10.75-6.2a.6.6,0,0,0,0-.856l-1.42-1.42a.6.6,0,0,0-.856,0L11.863,5.785,14.14,8.061,15.25,6.95Z"
                              transform="translate(-4.5 -4.496)"
                              fill="#1b3e6f6b"
                            />
                          </svg>
                        </Button>
                      </>
                    )}
                  </span>
                </div>
                <div className="kt-widget__info mb-2">
                  <span className="kt-widget__label">State :</span>
                  <span className="kt-widget__data">
                    {/* {values.stateName || "N/A"} */}
                    {isEditingst ? (
                      <Input
                        className="sel-size"
                        type="select"
                        name="stateName"
                        id="stateName"
                        value={parseInt(stname)}
                        onChange={handlestateChange}
                        // onBlur={handleBlur}
                        invalid={
                          touched.stateName && errors.stateName ? true : false
                        }
                        placeholder="State"
                      >
                        <option key="1" value="">
                          Select State
                        </option>
                        ;
                        {stateList.map((list) => {
                          const { stateId, stateName } = list;

                          return (
                            <option key={stateId} value={stateId}>
                              {stateName}
                            </option>
                          );
                        })}
                      </Input>
                    ) : (
                      <>
                        {stateList.find((state) => state.stateId === stname)
                          ?.stateName || "N/A"}
                        <Button
                          className="editBtn"
                          color="link"
                          onClick={handleEditClickst}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10.928"
                            height="10.928"
                            viewBox="0 0 10.928 10.928"
                          >
                            <path
                              id="Icon_material-mode-edit"
                              data-name="Icon material-mode-edit"
                              d="M4.5,13.148v2.276H6.776L13.49,8.711,11.214,6.434Zm10.75-6.2a.6.6,0,0,0,0-.856l-1.42-1.42a.6.6,0,0,0-.856,0L11.863,5.785,14.14,8.061,15.25,6.95Z"
                              transform="translate(-4.5 -4.496)"
                              fill="#1b3e6f6b"
                            />
                          </svg>
                        </Button>
                      </>
                    )}
                  </span>
                </div>
                <div className="kt-widget__info mb-2">
                  <span className="kt-widget__label">Postal Code :</span>
                  {/* <span className="kt-widget__data">{values.zip || "N/A"}</span> */}
                  <span className="kt-widget__data">
                    {isEditingps ? (
                      <input
                        type="text"
                        value={pscode}
                        onChange={handlezipChange}
                        placeholder="Enter Address"
                        className="form-control"
                      />
                    ) : (
                      <>
                        {pscode || "N/A"}
                        <Button
                          className="editBtn"
                          color="link"
                          onClick={handleEditClickps}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10.928"
                            height="10.928"
                            viewBox="0 0 10.928 10.928"
                          >
                            <path
                              id="Icon_material-mode-edit"
                              data-name="Icon material-mode-edit"
                              d="M4.5,13.148v2.276H6.776L13.49,8.711,11.214,6.434Zm10.75-6.2a.6.6,0,0,0,0-.856l-1.42-1.42a.6.6,0,0,0-.856,0L11.863,5.785,14.14,8.061,15.25,6.95Z"
                              transform="translate(-4.5 -4.496)"
                              fill="#1b3e6f6b"
                            />
                          </svg>
                        </Button>
                      </>
                    )}
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col md={6}>
          <div>
            {/* <HeaderLogo /> */}
            {texloading && <CustomPageLoading />}
            <Container>
              {/* <h4 className="pay-title">Complete Payment </h4> */}

              {/* <div className="page-title pay-text"></div> */}

              {/* <div className="new-license"> */}
              {/* <Row>
                <Col sm="12" md={{ size: 5 }} className="mr-auto ml-auto"> */}
              <div className="payment-info">
                <Table responsive>
                  <tbody>
                    <tr>
                      <td>{paymentValues.typeofLicense}</td>
                      <td>${parseFloat(planAmount).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td>Convenience Fee</td>
                      <td>${parseFloat(agencyFee).toFixed(2)}</td>
                    </tr>
                    <tr className="divide">
                      <td>
                        <b>Sub Total</b>
                      </td>
                      <td>
                        <b>${parseFloat(Total).toFixed(2)}</b>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
              {isPaymentSuccess ? (
                <div style={{ marginTop: "10px" }}>
                  <Alert color="success">
                    <h4 className="alert-heading">Payment Success!</h4>
                    <p>
                      You have successfully paid
                      <b> ${parseFloat(Total).toFixed(2)} </b> for this
                      certificate.
                    </p>
                    <hr />
                    <p className="mb-0">
                      {/* <a
                        //  href="#"
                        //  onClick={captureAndDownloadPDF}
                        // href="https://dev-paypup.azurewebsites.net/customer/ldragopettest/view-license/228/575/certificate.pdf"
                        // href="https://dev-paypup.azurewebsites.net/customer/ldragopettest/view-license/228/575"
                        href={documentUrl}
                        // target="_top"
                        // rel="noreferrer noopener"
                        // download="certificate.pdf"
                        style={{
                          color: "#fff",
                          border: "1px solid #eee",
                          backgroundColor: "firebrick",
                          padding: "8px",
                        }}
                      >
                        <i className="fas fa-file-download"></i>
                        {"  "} Certificate
                      </a> */}
                            <Button
                                  variant="contained"
                                  color="error"
                                  onClick={captureAndDownloadPDF}
                                  type="button"
                                  style={{
                                    color: "#fff",
                                    border: "1px solid #eee",
                                    backgroundColor: "firebrick",
                                    padding: "8px",
                                    marginLeft: "10px",
                                    marginTop: "-4px",
                                  }}
                                > <i className="fas fa-file-download"></i> {"  "}
                                  Certificate
                                </Button>
                      <Button
                        style={{ marginLeft: "10px", marginTop: "-4px" }}
                        type="button"
                        color="primary"
                        onClick={reset}
                      >
                        Apply More
                      </Button>
                    </p>
                  </Alert>
                </div>
              ) : (
                <div className="pmt-info-form">
                  {/* <div className="divider"></div> */}
                  <center>
                    <p style={{ marginTop: "12px" }}>Add payment card</p>
                  </center>
                  <Form onSubmit={handleSubmit}>
                    {/* <FormGroup>
                    <Label for="Card Number">First name</Label>
                    <Input
                      type="text"
                      name="firstName"
                      handleBlur={handleBlur}
                      placeholder="Enter first name"
                      invalid={
                        errors.firstName && touched.firstName ? true : false
                      }
                      value={values.firstName}
                      onChange={CardHolderHandle}
                    />
                    <FormFeedback>
                      {errors.firstName && touched.firstName
                        ? errors.firstName
                        : ""}
                    </FormFeedback>
                  </FormGroup>
                  <FormGroup>
                    <Label for="Card Number">Last name</Label>
                    <Input
                      type="text"
                      name="lastName"
                      handleBlur={handleBlur}
                      placeholder="Enter last name"
                      invalid={
                        errors.lastName && touched.lastName ? true : false
                      }
                      value={values.lastName}
                      onChange={CardHolderHandle}
                    />
                    <FormFeedback>
                      {errors.lastName && touched.lastName
                        ? errors.lastName
                        : ""}
                    </FormFeedback>
                  </FormGroup> */}
                    <FormGroup>
                      <Label for="Card Number">Card Number</Label>
                      <Input
                        type="text"
                        name="cardNumber"
                        placeholder="Enter Card number"
                        handleBlur={handleBlur}
                        invalid={
                          errors.cardNumber && touched.cardNumber ? true : false
                        }
                        value={values.cardNumber}
                        onChange={CardHandle}
                      />
                      <FormFeedback>
                        {errors.cardNumber && touched.cardNumber
                          ? errors.cardNumber
                          : ""}
                      </FormFeedback>
                    </FormGroup>
                    <Row form>
                      <Col lg="6" xl="4">
                        <FormGroup>
                          <Label for="Expiration">Expiration month</Label>
                          <Input
                            type="select"
                            name="expirationMonth"
                            handleBlur={handleBlur}
                            invalid={
                              errors.expirationMonth && touched.expirationMonth
                                ? true
                                : false
                            }
                            value={values.expirationMonth}
                            onChange={handleChange}
                          >
                            <option value="">Select Month</option>
                            {[
                              "01",
                              "02",
                              "03",
                              "04",
                              "05",
                              "06",
                              "07",
                              "08",
                              "09",
                              "10",
                              "11",
                              "12",
                            ].map((i, index) => (
                              <option value={i}>{i}</option>
                            ))}
                          </Input>
                          <FormFeedback>
                            {errors.expirationMonth && touched.expirationMonth
                              ? errors.expirationMonth
                              : ""}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col lg="6" xl="4">
                        <FormGroup>
                          <Label for="Expiration">Year</Label>
                          <Input
                            type="select"
                            handleBlur={handleBlur}
                            invalid={
                              errors.expirationYear && touched.expirationYear
                                ? true
                                : false
                            }
                            value={values.expirationYear}
                            onChange={handleChange}
                            name="expirationYear"
                            id="exampleSelect"
                          >
                            <option value="">Select Year</option>
                            {year.map((i, index) => (
                              <option value={i.value}>{i.year}</option>
                            ))}
                          </Input>
                          <FormFeedback>
                            {errors.expirationYear && touched.expirationYear
                              ? errors.expirationYear
                              : ""}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col lg="6" xl="4">
                        <FormGroup>
                          <Label for="Card Number">cvv</Label>
                          <Input
                            type="password"
                            handleBlur={handleBlur}
                            invalid={errors.cvv2 && touched.cvv2 ? true : false}
                            value={values.cvv2}
                            onChange={handleChange}
                            name="cvv2"
                            id="exampleSelect"
                          />

                          <FormFeedback>
                            {errors.cvv2 && touched.cvv2 ? errors.cvv2 : ""}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className="text-center">
                      <Button
                        disabled={loading}
                        className="ln-btn"
                        type="submit"
                        color="primary"
                        size="lg"
                      >
                        {paymentLoader && (
                          <CustomButtonLoader loading={paymentLoader} />
                        )}
                        Payment
                      </Button>
                    </div>
                  </Form>
                </div>
              )}
              {/* </Col>
              </Row> */}
              {/* </div> */}
            </Container>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
}
